import React         from 'react';
import _             from 'lodash';
import numeral       from 'numeral';
import Cart          from 'pu-react/components/ProductCartForm';

const getLineItem = (props) => {
  const lineItem = props.quote.line_items[0];
  if (lineItem.quantities && lineItem.lead_times && lineItem.pricing) {
    return lineItem;
  }
  return null;
};

const getRow = (props) => {
  const n = _.parseInt(props.parameters.row_selected);
  return _.isInteger(n) ? n : null;
};

const getColumn = (props) => {
  const n = _.parseInt(props.parameters.column_selected);
  return _.isInteger(n) ? n : null;
};

export default (props) => {
  let unitPrice;
  let totalPrice;
  let quantity;
  let leadTime;

  const row = getRow(props);
  const col = getColumn(props);
  const lineItem = getLineItem(props);
  if (lineItem && row !== null && col !== null) {
    quantity = lineItem.quantities[row];
    leadTime = lineItem.lead_times[col];
    const pricing = lineItem.pricing;
    if (pricing[row] !== undefined && pricing[row][col] !== undefined) {
      unitPrice = parseFloat(pricing[row][col]) / parseFloat(quantity);
      unitPrice = accounting.toFixed(unitPrice, 4);
      totalPrice = accounting.toFixed(unitPrice * parseFloat(quantity), 2);

      unitPrice = accounting.formatMoney(unitPrice, {precision: 4});
      totalPrice = accounting.formatMoney(totalPrice);
    }
  }

  const properties = [
    { label: 'Qty:', value: quantity },
    { label: 'Lead Time:', value: leadTime },
  ];

  return (
    <div>
      <Cart
        quoteStep={props.quoteStep}
        properties={properties}
        unitPrice={unitPrice}
        totalPrice={totalPrice}
        parametersChanged={props.parametersChanged} />
    </div>
  );
};
